function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect } from 'react';
import useHover from '../../hooks/use-hover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { chain } from 'lodash';
import { isMobile } from '../../utils';
import { SUB_FILE_SORTBY_CRITERIAS, SUB_FILE_SORTBY_ORDERS } from '../../utils/render';
import LoadingSpinner from '../loading-spinner';
import { faFile, faFolder, faFolderOpen, faAngleRight, faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { faDownload, faTrash } from '@fortawesome/pro-solid-svg-icons';
import FileSpinner from '../styled/file-spinner';
import { FileContents, File, FileIcon, FileButton, FolderArrowIcon, FileName, FileLink, FolderContentsWrapper, FolderContents, DateWrapper } from './styled';
import { formatDate } from '../../utils/date';
const defaultFileEmptyFolder = {
  id: 'empty',
  isFolder: false,
  name: 'Dossier vide'
};
const FileView = _ref => {
  let {
    indent = 0,
    disabled,
    isEmptyFolderPlaceholder,
    onClick,
    onFileDelete,
    onFileDownload,
    getFileDownloadLink,
    expandedFolders,
    loadingFilesIds,
    files,
    theme,
    canRead,
    canWrite,
    ...file
  } = _ref;
  const [clicked, setClicked] = useState(false);
  const expanded = expandedFolders.includes(file.id);
  const loading = loadingFilesIds.includes(file.id);
  useEffect(() => {
    setClicked(false);
  }, [expanded]);
  const shouldSubRender = file.isFolder && expanded;
  const icon = file.isFolder ? shouldSubRender ? faFolderOpen : faFolder : faFile;
  const subFiles = shouldSubRender ? files.filter(f => f.parent === file.id) : [];
  const [isFileTreeHovered, bindFileTreeHover] = useHover();
  const showDeleteBtn = () => {
    if (files && file && file.parent) {
      const fileParent = files.find(_ref2 => {
        let {
          id
        } = _ref2;
        return id === file.parent;
      });
      if (fileParent && fileParent.name === 'Mes documents') {
        return true;
      }
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileContents, _extends({}, bindFileTreeHover(), {
    disabled: isEmptyFolderPlaceholder,
    onClick: () => setClicked(true),
    isOpened: shouldSubRender
  }), isMobile && expanded ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(File, {
    indent: indent,
    value: file.id,
    "data-isfolder": file.isFolder,
    "data-mimetype": file.type,
    isOpened: shouldSubRender,
    onClick: typeof onClick === 'function' && onClick || null,
    className: !isEmptyFolderPlaceholder && clicked ? 'highlight' : '',
    disabled: loading
  }, !isEmptyFolderPlaceholder && /*#__PURE__*/React.createElement(FileIcon, {
    isFolder: file.isFolder
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon,
    size: "lg",
    color: theme.colors.primarySemiLight,
    fixedWidth: true
  })), /*#__PURE__*/React.createElement(FileName, {
    isPlaceholder: isEmptyFolderPlaceholder,
    isFolder: file.isFolder
  }, file.name), file.isFolder && /*#__PURE__*/React.createElement(FolderArrowIcon, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: shouldSubRender ? faAngleDown : faAngleRight,
    size: "lg",
    color: isFileTreeHovered ? theme.colors.primary : theme.colors.primarySemiLight
  }))), !file.isFolder && !loading && !disabled && /*#__PURE__*/React.createElement(React.Fragment, null, file?.createdAt && /*#__PURE__*/React.createElement(DateWrapper, null, formatDate(file?.createdAt)), /*#__PURE__*/React.createElement(FileLink, {
    name: file.name,
    value: file.id,
    "data-mimetype": file.type,
    onClick: onFileDownload,
    showDeleteBtn: String(showDeleteBtn())
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faDownload,
    size: "lg",
    color: theme.colors.primary,
    fixedWidth: true
  })), showDeleteBtn() && /*#__PURE__*/React.createElement(FileButton, {
    name: file.name,
    value: file.id,
    "data-mimetype": file.type,
    onClick: onFileDelete,
    disabled: !canWrite
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTrash,
    size: "lg",
    color: "#F13426",
    fixedWidth: true
  }))), loading && /*#__PURE__*/React.createElement(FileSpinner, null, /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: 16
  }))), shouldSubRender && /*#__PURE__*/React.createElement(FolderContents, null, /*#__PURE__*/React.createElement(FolderContentsWrapper, null, subFiles.length ? chain(subFiles).orderBy(SUB_FILE_SORTBY_CRITERIAS, SUB_FILE_SORTBY_ORDERS).map(f => /*#__PURE__*/React.createElement(FileView, _extends({
    key: f.id,
    indent: indent + 1,
    expandedFolders: expandedFolders,
    loadingFilesIds: loadingFilesIds,
    disabled: disabled,
    onClick: onClick,
    onFileDelete: onFileDelete,
    onFileDownload: onFileDownload,
    theme: theme,
    getFileDownloadLink: getFileDownloadLink,
    files: files,
    canRead: canRead,
    canWrite: canWrite
  }, f))).value() : /*#__PURE__*/React.createElement(FileView, _extends({
    indent: indent + 1,
    expandedFolders: expandedFolders,
    loadingFilesIds: loadingFilesIds,
    disabled: true,
    onClick: true,
    onFileDelete: true,
    onFileDownload: true,
    theme: theme,
    getFileDownloadLink: getFileDownloadLink,
    files: files,
    isEmptyFolderPlaceholder: true,
    canRead: canRead,
    canWrite: canWrite
  }, defaultFileEmptyFolder)))));
};
export default FileView;